<template>
  <div class="wait-move">
    <el-form :inline="true" :model="formInline" label-position="left" @keydown.enter="onSubmit"
      class="demo-form-inline">
      <el-form-item label="原批次包编码: ">
        <el-input maxlength='450' v-model="formInline.pkgCode" @keydown.native.enter="onSubmit" placeholder="原批次包编码"></el-input>
      </el-form-item>
      <el-form-item label="商品sku: ">
        <el-input maxlength='450' v-model="formInline.shopProductSku" @keydown.native.enter="onSubmit" placeholder="搜索商品sku"></el-input>
      </el-form-item>
      <el-form-item label="调拨拣货状态：">
        <el-select v-model="formInline.status" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="待调拨" :value="0"></el-option>
          <el-option label="调拨拣货中" :value="1"></el-option>
          <el-option label="调拨完成" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
        <el-button type="primary" @click="create" :disabled="createFlag">导入PDA（生成任务）</el-button>
      </el-form-item>
    </el-form>
    <WmsTable :columns="moveColumns" @pageChange="pageChangeCall" :dataSource="dataSource" :isPagination="query" 
      :isRowSelection="true" @selectChange="selChange" :clean="clean" ref="wmsTable">
      <div slot="img" slot-scope="{record}">
        <ImgPreviews :images="[record.productImg]"></ImgPreviews>
      </div>
      <div slot="action" slot-scope="{record}" style="color:#40A9FF;cursor: pointer;" @click="print(record)">
        打印新批次条码
      </div>
    </WmsTable>
  </div>
</template>
<script>
import ImgPreviews from "@/components/ImgPreviews";
import WmsTable from "@/components/WmsTable";
import { moveColumns } from "./combinTable";
import { Table } from "ant-design-vue";
import { packAllotPage, createAllotPick,createAllotPickNew } from "@/apis/combination";
export default {
  title: "待调拨",
  name: "waitMove",
  components: {
    WmsTable,
    [Table.name]: Table,
    ImgPreviews
  },
  data() {
    return {
      moveColumns,
      formInline: {},
      dataSource: [],
      selArray: [],
      params: {},
      clean: false,
      query: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    };
  },
  computed: {
    createFlag: function () {
      return this.selArray.length == 0 || this.selArray.some(item => item.status != 0)
    },
  },
  methods: {
    getList() {
      let params = {
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline,
      };
      packAllotPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
    onSubmit() {
      this.$refs.wmsTable.resetSel()
      this.selArray = []
      this.clean = new Date()
      this.query.current = 1
      this.getList();
    },
    restSubmit() {
      this.$refs.wmsTable.resetSel()
      this.formInline = {};
      this.query = {
        pageSize: 10,
        current: 0,
        total: 1,
      };
      this.getList();
    },
    selChange(sel) {
      console.log(sel)
      this.selArray = sel
    },
    create() {
      if (!this.selArray.length) {
        this.$message.warning('请勾选任务')
        return;
      }
      let orderCodes = []
      this.selArray.forEach(item => {
        orderCodes.push(item.id)
      })
      createAllotPickNew(orderCodes).then(({ code, data }) => {
        if (code === 0) {
          this.selArray = []
          this.clean = new Date()
          this.$message.success('导入成功')
          this.getList()
        }
      })
    },
    print(record) {
      let data = {...record}
      data.pkgCode = data.newPkgCode
      console.log(data)
      
      this.$wmsPrint.print().templatePrintByPkg([data])
    }
  },
  created() { },
};
</script>
<style lang="less" scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
